// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","cardContainer":"_3IUq71a6IwdtqWojNcQLCE"};